export default "__VITE_ASSET__BEQNc55L__"